import React, { useCallback } from "react";
import { actions } from "./redux/slice";
import Input from "app/components/Input";
import { useDispatch, useSelector } from "react-redux";
import { selectButtonLoading, selectTagsForm } from "./redux/selector";

const UpdateName: React.FC = ({}) => {
  const dispatch = useDispatch();
  const loading = useSelector(selectButtonLoading);
  const { title } = useSelector(selectTagsForm);

  const onCreate = () => {
    dispatch(
      actions.updateTags({
        callback: () => {
          handleClose();
        },
      }),
    );
  };

  const handleClose = () => {
    dispatch(actions.setIsSelectedId(""));
    dispatch(actions.clearForm());
  };

  const handleInputKeyDown = useCallback(
    (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === "Escape") {
        (e.currentTarget as HTMLInputElement).blur();
        handleClose();
      }
      if (e.key === "Enter") {
        e.preventDefault();
        onCreate();
      }
    },
    [onCreate],
  );

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    e.stopPropagation();
    dispatch(actions.updateFormValue({ key: name, value: value }));
  };
  return (
    <div className=" w-full relative group px-4 ">
      <Input
        id="title"
        name="title"
        value={title}
        onChange={handleChange}
        onKeyDown={handleInputKeyDown}
        maxLength={100}
        disabled={loading}
        autoFocus
      />
    </div>
  );
};

export default UpdateName;
